import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { TenantProvider } from './contexts/TenantContext';
import { ToastProvider } from './contexts/ToastContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <TenantProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </TenantProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// iOS Safari requires add-to-home-screen for persistent SW storage;
// standard SW behaviour still provides in-session offline use without installation.
serviceWorkerRegistration.register({
  onUpdate: () => window.dispatchEvent(new CustomEvent('sw-update-available')),
});

reportWebVitals();
